module.exports = __webpack_public_path__ + "img/dyqh1.16ab6057.jpg";